import React, { useEffect } from 'react';
import Navbar from '../../components/Navbar';
import Footer from '../../components/Footer';
import './BestRehabEquipmentSupplier.css';

const BestRehabEquipmentSupplier = () => {
  useEffect(() => {
    window.scrollTo(0, 0);

    const schema = {
      "@context": "https://schema.org",
      "@graph": [
        {
          "@type": "Organization",
          "@id": "https://www.primerehabindustries.in/#organization",
          "name": "Prime Rehab Industries",
          "url": "https://www.primerehabindustries.in",
          "telephone": "+919994351947",
          "email": "primerehaboffl@gmail.com",
          "logo": {
            "@type": "ImageObject",
            "url": "https://primerehabindustries.in/Image/Logo.png"
          }
        },
        {
          "@type": "LocalBusiness",
          "@id": "https://www.primerehabindustries.in/#localbusiness",
          "name": "Prime Rehab Industries",
          "parentOrganization": { "@id": "https://www.primerehabindustries.in/#organization" },
          "description": "Prime Rehab Industries manufactures clinically engineered physiotherapy and rehabilitation equipment for clinics, hospitals, and rehabilitation centres across Tamil Nadu and India.",
          "address": {
            "@type": "PostalAddress",
            "addressLocality": "Chennai",
            "addressRegion": "Tamil Nadu",
            "addressCountry": "IN"
          },
          "telephone": "+919994351947",
          "email": "primerehaboffl@gmail.com",
          "url": "https://www.primerehabindustries.in",
          "sameAs": [
            "https://www.google.com/maps/search/?api=1&query=Prime+Rehab+Industries%2C+Plot+No+4%2C+Kandasamy+Nagar+Annex%2C+Vanagaram%2C+Chennai+600095"
          ],
          "areaServed": ["Tamil Nadu", "India"],
          "openingHours": "Mo-Sa 09:00-18:00"
        },
        {
          "@type": "Product",
          "name": "Physiotherapy and Rehabilitation Equipment",
          "description": "Clinically engineered physiotherapy and rehabilitation equipment including treatment tables, chiropractic tables, tilting tables, traction tables, Bobath tables, and unweighing systems. Trusted by 500+ clinics and hospitals across India.",
          "brand": { "@id": "https://www.primerehabindustries.in/#organization" },
          "manufacturer": { "@id": "https://www.primerehabindustries.in/#organization" }
        },
        {
          "@type": "FAQPage",
          "mainEntity": [
            {
              "@type": "Question",
              "name": "What types of rehabilitation equipment does Prime Rehab Industries manufacture?",
              "acceptedAnswer": {
                "@type": "Answer",
                "text": "Prime Rehab Industries manufactures over 100 models of physiotherapy and rehabilitation equipment including treatment tables, chiropractic tables, tilting tables, traction tables, Bobath tables, and unweighing systems. The range covers physiotherapy, chiropractic, orthopaedic, and neurological rehabilitation."
              }
            },
            {
              "@type": "Question",
              "name": "Does Prime Rehab Industries supply equipment to hospitals in Tamil Nadu?",
              "acceptedAnswer": {
                "@type": "Answer",
                "text": "Yes. Prime Rehab Industries supplies equipment to clinics, hospitals, and rehabilitation centres across Tamil Nadu and India. With 500+ facilities served and 1,000+ installations completed, the company is a trusted supplier for healthcare institutions of all sizes."
              }
            },
            {
              "@type": "Question",
              "name": "Can I get custom-sized physiotherapy equipment from Prime Rehab Industries?",
              "acceptedAnswer": {
                "@type": "Answer",
                "text": "Yes. Prime Rehab Industries offers custom equipment sizes to suit different clinic layouts and patient requirements. Contact the team with your specifications and they will provide a solution tailored to your setup."
              }
            },
            {
              "@type": "Question",
              "name": "How experienced is Prime Rehab Industries in physiotherapy equipment manufacturing?",
              "acceptedAnswer": {
                "@type": "Answer",
                "text": "Prime Rehab Industries has over 12 years of experience manufacturing physiotherapy and rehabilitation equipment. Based in Chennai, Tamil Nadu, the company serves healthcare professionals across India with a focus on quality engineering and practical clinical design."
              }
            }
          ]
        },
        {
          "@type": "BreadcrumbList",
          "itemListElement": [
            {
              "@type": "ListItem",
              "position": 1,
              "name": "Home",
              "item": "https://www.primerehabindustries.in"
            },
            {
              "@type": "ListItem",
              "position": 2,
              "name": "Blog",
              "item": "https://www.primerehabindustries.in/blog"
            },
            {
              "@type": "ListItem",
              "position": 3,
              "name": "Best Rehabilitation Equipment Supplier in Tamil Nadu",
              "item": "https://www.primerehabindustries.in/blog/best-rehabilitation-equipment-supplier-tamil-nadu"
            }
          ]
        }
      ]
    };

    document.title = "Rehabilitation Equipment Supplier Tamil Nadu | Prime Rehab";

    let metaDesc = document.querySelector('meta[name="description"]');
    if (!metaDesc) {
      metaDesc = document.createElement('meta');
      metaDesc.name = "description";
      document.head.appendChild(metaDesc);
    }
    metaDesc.content = "Prime Rehab Industries is a trusted rehabilitation equipment supplier in Tamil Nadu with 12+ years, 100+ products, and 500+ clinics served across India.";

    let canonical = document.querySelector('link[rel="canonical"]');
    if (!canonical) {
      canonical = document.createElement('link');
      canonical.rel = "canonical";
      document.head.appendChild(canonical);
    }
    canonical.href = "https://www.primerehabindustries.in/blog/best-rehabilitation-equipment-supplier-tamil-nadu";

    let script = document.querySelector('#blog-schema');
    if (!script) {
      script = document.createElement('script');
      script.id = 'blog-schema';
      script.type = 'application/ld+json';
      document.head.appendChild(script);
    }
    script.innerHTML = JSON.stringify(schema);

    return () => {
      // Clean up if necessary
    };
  }, []);

  return (
    <div className="landing-blog-page">
      <Navbar />
      
      {/* Hero Section */}
      <section className="landing-hero" style={{ backgroundImage: 'linear-gradient(rgba(13, 31, 54, 0.8), rgba(13, 31, 54, 0.9)), url("https://primerehabindustries.in/Image/Product/Pro1.png")' }}>
        <div className="landing-hero-content">
          <div className="landing-category-tag">Rehabilitation Equipment Guide</div>
          <h1>Best Rehabilitation Equipment Supplier in Tamil Nadu</h1>
          <p>
            Running a physiotherapy clinic or managing a hospital rehabilitation wing comes with a constant challenge finding equipment you can truly rely on. Not just for today, but for years of daily clinical use, patient after patient.
          </p>
          <div className="landing-hero-actions">
            <a href="tel:+919994351947" className="btn-primary">Call Now +91 99943 51947</a>
            <a href="/contact" className="btn-secondary">Get a Quote</a>
          </div>
        </div>
      </section>

      {/* Intro Section */}
      <section className="landing-intro">
        <div className="landing-container">
          <div className="landing-intro-text">
            <h2>Why Choosing the Right Rehabilitation Equipment Supplier Matters</h2>
            <p>
              If you've been searching for a dependable rehabilitation equipment supplier in Tamil Nadu, the choices can feel overwhelming. But the right decision comes down to one thing: who stands behind the equipment they sell.
            </p>
            <p>
              Prime Rehab Industries has spent over 12 years answering that question for clinics, hospitals, and rehabilitation centres across India. With more than 100 equipment models, 500 clinics served, and 1,000 successful installations, Prime Rehab has earned its reputation as the trusted name for physiotherapy and rehabilitation equipment in Tamil Nadu.
            </p>
            <p>
              Poor-quality equipment breaks down at the worst times mid-session, under a patient's weight, or during a critical neurological rehabilitation exercise. The cost isn't just financial. It's the disruption to treatment, the patient's loss of confidence, and the added pressure on your clinical team.
            </p>
            <p>
              A reliable supplier ensures that every table, every frame, and every mechanism is built for real clinical conditions not just for a product catalogue photograph. That is the standard Prime Rehab Industries holds itself to with every unit it manufactures.
            </p>
          </div>
        </div>
      </section>

      {/* Features Grid */}
      <section className="landing-features">
        <div className="landing-container">
          <div className="section-header">
            <h2>What Makes Prime Rehab Industries the Leading Supplier in Tamil Nadu</h2>
            <p>Excellence in engineering, trusted by professionals.</p>
          </div>
          
          <div className="features-grid">
            <div className="feature-card">
              <div className="feature-number">01</div>
              <h3>Clinically Engineered Equipment</h3>
              <p>Every Prime Rehab product is designed with clinical performance in mind. Strong metal frames, precision-engineered mechanisms, and comfortable rexine upholstery combine to create equipment that withstands the demands of continuous clinical use.</p>
            </div>
            
            <div className="feature-card">
              <div className="feature-number">02</div>
              <h3>A Complete Range Covering All Needs</h3>
              <p>Over 100 equipment models covering physiotherapy, chiropractic, orthopaedic, and neurological treatments. From spinal decompression therapy to gait training and walking rehabilitation, we cover all specialities.</p>
            </div>
            
            <div className="feature-card">
              <div className="feature-number">03</div>
              <h3>Custom Sizes Available</h3>
              <p>No two clinics are the same. We offer custom equipment sizes on request. Whether fitting equipment into a compact urban clinic or a large hospital, we deliver the right solution for your space.</p>
            </div>
            
            <div className="feature-card">
              <div className="feature-number">04</div>
              <h3>Trusted by 500+ Clinics</h3>
              <p>With over 500 clinics served and more than 1,000 installations completed, our track record is built on consistent quality, responsive support, and equipment that performs as promised from day one.</p>
            </div>
            
            <div className="feature-card">
              <div className="feature-number">05</div>
              <h3>Ergonomic Design</h3>
              <p>Designed for both therapists and patients. Adjustable heights, smooth motorized mechanisms, lockable wheels, and high-density foam padding work together to reduce strain and improve clinical outcomes.</p>
            </div>
          </div>
        </div>
      </section>

      {/* Testimonial Section */}
      <section className="landing-testimonial">
        <div className="landing-container">
          <div className="testimonial-wrapper">
            <div className="testimonial-quote">
              <svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" viewBox="0 0 24 24" fill="currentColor">
                <path d="M14.017 21v-7.391c0-5.704 3.731-9.57 8.983-10.609l.995 2.151c-2.432.917-3.995 3.638-3.995 5.849h4v10h-9.983zm-14.017 0v-7.391c0-5.704 3.748-9.57 9-10.609l.996 2.151c-2.433.917-3.996 3.638-3.996 5.849h3.983v10h-9.983z"/>
              </svg>
              <blockquote>
                "Prime Rehab equipment is reliable and well-designed. It has improved the efficiency of treatments in our physiotherapy clinic. The build quality on the treatment tables is excellent we've had them in daily use for over two years with no issues."
              </blockquote>
              <div className="testimonial-author">
                <strong>Dr. Arun Kumar</strong>
                <span>Physiotherapist</span>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Equipment Range */}
      <section className="landing-equipment">
        <div className="landing-container">
          <div className="section-header">
            <h2>Prime Rehab's Physiotherapy Equipment Range</h2>
            <p>Here is a look at the core equipment categories available from Prime Rehab Industries:</p>
          </div>
          
          <div className="equipment-grid1">
            <div className="equipment-card">
              <div className="equipment-icon">
                <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16m-7 6h7" />
                </svg>
              </div>
              <h3>Treatment and Therapy Tables</h3>
              <p>Includes High Low Traction Table, High Low Bobath Table, and High Low 3-Fold Table with remote controlled motorized operation and high density foam padding.</p>
            </div>
            
            <div className="equipment-card">
              <div className="equipment-icon">
                <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 11H5m14 0a2 2 0 012 2v6a2 2 0 01-2 2H5a2 2 0 01-2-2v-6a2 2 0 012-2m14 0V9a2 2 0 00-2-2M5 11V9a2 2 0 012-2m0 0V5a2 2 0 012-2h6a2 2 0 012 2v2M7 7h10" />
                </svg>
              </div>
              <h3>Specialist Chiropractic Equipment</h3>
              <p>The Chiropractic Drop Table features a multi-section drop mechanism, electric height control, and adjustable drop tension for precise, safe adjustments.</p>
            </div>
            
            <div className="equipment-card">
              <div className="equipment-icon">
                <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 10V3L4 14h7v7l9-11h-7z" />
                </svg>
              </div>
              <h3>Gait Training & Unweighing Systems</h3>
              <p>Supports patients through standing and gait rehabilitation with a motorized DC lifting mechanism, digital weight display, and safety harness.</p>
            </div>
            
            <div className="equipment-card">
              <div className="equipment-icon">
                <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 8V4m0 0h4M4 4l5 5m11-1V4m0 0h-4m4 0l-5 5M4 16v4m0 0h4m-4 0l5-5m11 5l-5-5m5 5v-4m0 4h-4" />
                </svg>
              </div>
              <h3>Tilting and Positioning Tables</h3>
              <p>High Low and Fixed Height Tilting Tables offer motorized tilt control with safety harness support for neurological and orthopaedic patients.</p>
            </div>
          </div>
        </div>
      </section>

      {/* Second Testimonial */}
      <section className="landing-testimonial light-bg">
        <div className="landing-container">
          <div className="testimonial-wrapper">
            <div className="testimonial-quote">
              <svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" viewBox="0 0 24 24" fill="currentColor">
                <path d="M14.017 21v-7.391c0-5.704 3.731-9.57 8.983-10.609l.995 2.151c-2.432.917-3.995 3.638-3.995 5.849h4v10h-9.983zm-14.017 0v-7.391c0-5.704 3.748-9.57 9-10.609l.996 2.151c-2.433.917-3.996 3.638-3.996 5.849h3.983v10h-9.983z"/>
              </svg>
              <blockquote>
                "We equipped our rehabilitation centre with Prime Rehab's tables and the quality is outstanding. The motorized height adjustment works smoothly and the rexine upholstery has held up well through months of intensive use. Highly recommended for any serious rehab facility."
              </blockquote>
              <div className="testimonial-author">
                <strong>Dr. Priya Suresh</strong>
                <span>Rehabilitation Centre Manager, Chennai</span>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* How To Get Started Section */}
      <section className="landing-getting-started">
         <div className="landing-container">
           <div className="getting-started-content">
             <h2>How to Get Rehabilitation Equipment from Prime Rehab Industries</h2>
             <p>Getting started is straightforward. Visit our products page to browse the full range or contact our team directly for custom sizing. Prime Rehab Industries serves clinics, hospitals, and rehabilitation centres across Tamil Nadu and India. With our 12+ year track record and 1,000+ successful installations, you have the confidence to make the right choice.</p>
             <div className="action-buttons">
               <a href="/products" className="btn-outline">Browse Products</a>
               <a href="/contact" className="btn-primary">Contact the Team</a>
             </div>
           </div>
         </div>
      </section>

      {/* FAQ Section */}
      <section className="landing-faq">
        <div className="landing-container">
          <div className="section-header">
            <h2>Frequently Asked Questions</h2>
          </div>
          <div className="faq-list">
            <div className="faq-item">
              <h3>What types of rehabilitation equipment does Prime Rehab Industries manufacture?</h3>
              <p>Prime Rehab Industries manufactures over 100 models of physiotherapy and rehabilitation equipment including treatment tables, chiropractic tables, tilting tables, traction tables, Bobath tables, and unweighing systems. The range covers physiotherapy, chiropractic, orthopaedic, and neurological rehabilitation.</p>
            </div>
            <div className="faq-item">
              <h3>Does Prime Rehab Industries supply equipment to hospitals in Tamil Nadu?</h3>
              <p>Yes. Prime Rehab Industries supplies equipment to clinics, hospitals, and rehabilitation centres across Tamil Nadu and India. With 500+ facilities served and 1,000+ installations completed, the company is a trusted supplier for healthcare institutions of all sizes.</p>
            </div>
            <div className="faq-item">
              <h3>Can I get custom sized physiotherapy equipment from Prime Rehab Industries?</h3>
              <p>Yes. Prime Rehab Industries offers custom equipment sizes to suit different clinic layouts and patient requirements. Contact the team with your specifications and they will provide a solution tailored to your setup.</p>
            </div>
            <div className="faq-item">
              <h3>How experienced is Prime Rehab Industries in physiotherapy equipment manufacturing?</h3>
              <p>Prime Rehab Industries has over 12 years of experience manufacturing physiotherapy and rehabilitation equipment. Based in Chennai, Tamil Nadu, the company serves healthcare professionals across India with a focus on quality engineering and practical clinical design.</p>
            </div>
          </div>
        </div>
      </section>

      {/* CTA Bottom */}
      <section className="landing-cta-bottom">
        <div className="landing-container">
          <h2>Ready to Equip Your Clinic or Hospital?</h2>
          <p>Speak to the Prime Rehab Industries team about the right rehabilitation equipment for your facility. Custom sizes, full product range, and 12+ years of expertise — all in one place.</p>
          <div className="contact-info-cards">
            <div className="contact-card">
              <h4>Call Us Directly</h4>
              <p>+91 99943 51947</p>
              <a href="tel:+919994351947">Call Now</a>
            </div>
            <div className="contact-card">
              <h4>Visit Google Profile</h4>
              <p>Read Reviews & Location</p>
              <a href="https://www.google.com/maps/search/?api=1&query=Prime+Rehab+Industries%2C+Plot+No+4%2C+Kandasamy+Nagar+Annex%2C+Vanagaram%2C+Chennai+600095" target="_blank" rel="noopener noreferrer">View on Maps</a>
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default BestRehabEquipmentSupplier;
